module.exports = __webpack_public_path__ + "02_short_gray.cb99557e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_short_gray.png
// module id = ZQhu
// module chunks = 0